// import React from 'react';

// const TopBar = ({ userName, onLogout }) => {
//   return (
//     <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
//       <div className="container-fluid">
//         <a className="navbar-brand" href="/">Bee's Care Ltd</a>
//         <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
//           <span className="navbar-toggler-icon"></span>
//         </button>
//         <div className="collapse navbar-collapse" id="mynavbar">
//           <ul className="navbar-nav me-auto">
//             <li className="nav-item">
//               <a className="nav-link" href="/view-results">View Results</a>
//             </li>
          
//           </ul>
          
//             <button className="btn btn-outline-danger" onClick={onLogout}>
//           Logout
//         </button>
          
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default TopBar;




// import React from 'react';

// const TopBar = ({ userName, userEmail, onLogout }) => {
//   return (
//     <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
//       <div className="container-fluid">
//         <a className="navbar-brand" href="/">Bee's Care Ltd</a>
//         <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
//           <span className="navbar-toggler-icon"></span>
//         </button>
//         <div className="collapse navbar-collapse" id="mynavbar">
//           <ul className="navbar-nav me-auto">
//             {/* Conditionally render "View Results" link */}
//             {userEmail === "mobeensafdar2020@gmail.com" && (
//               <li className="nav-item">
//                 <a className="nav-link" href="/view-results">View Results</a>
//               </li>
//             )}
//           </ul>
//           <button className="btn btn-outline-danger" onClick={onLogout}>
//             Logout
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default TopBar;




import React from 'react';

const TopBar = ({ userName, userEmail, onLogout }) => {
  // Define allowed emails
  const allowedEmails = ["mobeensafdar2020@gmail.com", "bismillah.alam@beescare.co.uk"];

  return (
    <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">Bee's Care Ltd</a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="mynavbar">
          <ul className="navbar-nav me-auto">
            {/* Conditionally render "View Results" link for allowed emails */}
            {allowedEmails.includes(userEmail) && (
              <li className="nav-item">
                <a className="nav-link" href="/view-results">View Results</a>
              </li>
            )}
          </ul>
          <button className="btn btn-outline-danger" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
